import React from 'react';

import C from './Controller';

import MenuComponent from './MenuComponent';

import {
  Wrap, 
  Arrows,
  FrontWrap, Logo, Name, Logout,
  Nav, MenuWrap
} from './styled';

const Header = ({
  user_type,
  isMenuOpen, menus, userInfo,
  onClickUp, onClickDown, onClickToOpen
}) => {
  return (
    <Wrap>
      <FrontWrap>
        <Logo href="/admin/main">
          <svg width="60" height="40" viewBox="0 0 110 36.96">
            <g fill="#d8ac8a" fillRule="evenodd" transform="translate(-885 -999)">
                <path id="lect800" d="M0 0h17.511v2.981H0z" className="cls-2" data-name="lect800" transform="translate(933.285 1004.574)"/>
                <path id="path356" d="M82.362 18.332h-3.428v-6.185c0-.075 0-.075-.075-.075h-.075l-3.725-.372-.447.745v.075c.224 0 1.341.149 1.341.894v4.992h-4.62v-6.184c0-.075 0-.075-.075-.075l-3.726-.373-.447.745v.075c.224 0 1.118.075 1.341.671v5.216H65v2.981h17.511v-3.13z" className="cls-2" data-name="path 356" transform="translate(868.434 996.898)"/>
                <path id="path357" d="M105.467 15.836l-8.42.3V9.353h8.42V6.447c0-.075 0-.075-.075-.075h-8.941L93.247 6l-.447.745v.075c.224 0 1.341.149 1.341.894v12.071h.075l11.326-1.639v-2.31z" className="cls-2" data-name="path357" transform="translate(861.348 998.351)"/>
                <path id="path358" d="M116.547 3.873l-3.8-.373-.447.745v.075c.224 0 1.341.149 1.341.82v12.741a9.782 9.782 0 0 1 2.981 1.937V3.947a.073.073 0 0 0-.075-.074z" className="cls-2" data-name="path358" transform="translate(856.378 998.988)"/>
                <path id="path359" d="M108.547 25.59v-.373l-2.608-1.117-.6.522v.078a.76.76 0 0 1 .522.894 6.573 6.573 0 1 0 7.749 6.483 6.661 6.661 0 0 0-5.063-6.487zm-1.565 9.91a3.5 3.5 0 1 1 3.5-3.5 3.45 3.45 0 0 1-3.499 3.5z" className="cls-2" data-name="path359" transform="translate(859.386 993.738)"/>
                <path id="path360" d="M72.828 32.094c-2.533 0-4.992-.149-7.377-.373-1.267-.149-2.459-.3-3.651-.522l.745 3.13a.073.073 0 0 0 .075.075c.82.149 1.639.224 2.459.373a64.384 64.384 0 0 0 7.675.447 64.385 64.385 0 0 0 7.675-.447c.894-.075 1.788-.224 2.608-.373a.073.073 0 0 0 .075-.075l.745-3.13a52.817 52.817 0 0 1-3.8.6c-2.237.146-4.77.295-7.229.295z" className="cls-2" data-name="path360" transform="translate(869.249 991.928)"/>
                <path id="path361" d="M26.1 4.62h.149l3.5-2.533c.075-.075.075-.149 0-.149L28.636.149c0-.149-.075-.149-.075-.149h-4.769c-.075 0-.075 0-.075.075L22.6 1.863v.149z" className="cls-2" data-name="path361" transform="translate(879.24 999.88)"/>
                <path id="path362" d="M39.79 23.207c-1.043-.3-2.012-.671-3.055-1.043a11.465 11.465 0 0 1-1.416-.6c.149-.224.3-.373.447-.6l.447-.671a1.868 1.868 0 0 0 .3-.522 8.144 8.144 0 0 0 .6-1.118 9.93 9.93 0 0 0-.894-9.24A9.994 9.994 0 0 0 31.743 5.7a8.079 8.079 0 0 0-3.13-.6 6.506 6.506 0 0 0-2.31.373 11.96 11.96 0 0 0-3.651 2.012c-.447.373-.894.82-1.341 1.267-.149.149-.3.373-.447.522a.636.636 0 0 1-.969 0 3.241 3.241 0 0 0-.447-.522.26.26 0 0 1-.149-.075 13.081 13.081 0 0 0-3.651-2.757 7.745 7.745 0 0 0-3.5-.82 9.742 9.742 0 0 0-3.13.6 9.613 9.613 0 0 0-4.473 3.722 10.121 10.121 0 0 0-1.639 5.439 9.859 9.859 0 0 0 .745 3.8 8.144 8.144 0 0 0 .6 1.118 3.24 3.24 0 0 1 .3.522c.3.373.6.82.894 1.267-.447.224-.969.373-1.416.6-.969.373-2.012.745-2.981 1.043-.149.075-.3.149-.3.373L0 26.634a51.821 51.821 0 0 0 5.961-2.086c.447-.224.969-.373 1.416-.6.969-.447 1.863-.894 2.757-1.341l.447-.224a5.558 5.558 0 0 0 .894-.522 34.717 34.717 0 0 0 7.749-5.961 59.547 59.547 0 0 1-1.863-2.384 34.208 34.208 0 0 1-7.9 6.036c-.075.075-.224.075-.3.149a5.5 5.5 0 0 1-.969.6 10.662 10.662 0 0 1-.82-1.118l-.072-.075c-.224-.3-.373-.6-.522-.82a4.274 4.274 0 0 1-.3-.522C3.5 12.253 7.153 8.9 7.153 8.9c4.1-3.651 9.016.969 9.016.969a12.68 12.68 0 0 1 1.416 1.416c.3.373.6.745.969 1.192.224.3 1.49 1.937 1.863 2.384a14.3 14.3 0 0 0 1.043 1.118 39.11 39.11 0 0 0 7.749 5.961 26.1 26.1 0 0 0 2.012-2.31c-.075 0-.075-.075-.149-.075a33.493 33.493 0 0 1-7.824-5.961c-.373-.373-.671-.745-1.043-1.118a7.524 7.524 0 0 1 .969-1.192 3.241 3.241 0 0 1 .447-.522 14.3 14.3 0 0 1 1.117-1.042c.82-.671 5.141-4.1 8.867-.82 0 0 3.8 3.428.522 9.165-.075.075-.075.224-.149.3a1.629 1.629 0 0 0-.224.373c-.075.149-.224.3-.3.447a10.662 10.662 0 0 1-.82 1.118l-.075.075c-.6.745-1.267 1.49-2.012 2.31-.373.373-.671.745-1.043 1.118l-.671.671c-1.937 2.012-4.024 3.949-5.738 5.588l-.224.224a1.975 1.975 0 0 1-.447.373l-.373.373-.149.149-.3.3c-.373.3-.671.6-.969.82l-.224.224c-.3-.3-.671-.6-1.118-.969-1.341-1.192-3.13-2.906-4.992-4.694l-2.981-2.981c-.894.522-1.788.969-2.757 1.416l1.349 1.334c1.192 1.192 2.384 2.384 3.577 3.5 1.043.969 2.012 1.937 2.906 2.757a220.44 220.44 0 0 0 3.13 2.831l.969.82.969-.82.373-.373c.969-.894 3.8-3.353 6.706-6.259 1.267-1.267 2.608-2.608 3.8-3.875a14.3 14.3 0 0 0 1.042-1.115 11.464 11.464 0 0 0 1.416.6 58.339 58.339 0 0 0 6.036 2.086l-.745-3.055a.536.536 0 0 0-.299-.524z" className="cls-2" data-name="path362" transform="translate(885 998.58)"/>
            </g>
          </svg>
        </Logo>

        {userInfo.name ? <Name href="/my-account">{userInfo.name} 님</Name> : <Name href="/my-account">{userInfo.username} 님</Name>}
        
        {user_type !== '_agency' && userInfo.name && (
          <Logout href={`/${user_type}/logout`}>
            <svg width="16" height="16" viewBox="0 0 16 16">
              <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                <path d="M8.07 13.632H2.568V2.745h5.501M6.054 8.06h7.157M11.39 5.808l2.16 2.16-2.305 2.306"/>
              </g>
            </svg>
          </Logout>
        )}
      </FrontWrap>

      <Arrows>
        <button onClick={onClickUp}>
          <svg width="14" height="14" viewBox="0 0 32 32">
            <g data-name="441-Arrow up" id="_441-Arrow_up">
              <polyline fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="3px" points="1 23 16 9 31 23"/>
            </g>
          </svg>
        </button>

        <button onClick={onClickDown}>
          <svg width="14" height="14" viewBox="0 0 32 32">
            <g data-name="442-Arrow down" id="_442-Arrow_down">
              <polyline fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="3px" points="31 8 16 22 1 8"/>
            </g>
          </svg>
        </button>
      </Arrows>

      <Nav isOpen={isMenuOpen} user_type={user_type}>
        <div className="MenuBtn" onClick={onClickToOpen}>
          <div>
            <p className="Bar"></p>
            <p className="Bar"></p>
            <p className="Bar"></p>
          </div>
        </div>
        <MenuWrap height={window.innerHeight - 60}>
          {menus.map((menu, key) => <MenuComponent key={key} idx={key} title={menu.title || ''} childUrl={menu.menus} />)}
        </MenuWrap>
      </Nav>
    </Wrap>
  )
}

export default C(Header);


// WEBPACK FOOTER //
// ./client/components/Header/index.js